interface IconFootProps {
  active?: boolean;
  color?: string;
}
export const IconFoot = ({ active, color }: IconFootProps) => {
  const stroke = color ?? (active ? "#FF9934" : "#999999");
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0005 10.5615C12.8482 10.5616 13.3754 10.8568 13.8237 11.3018C14.062 11.5383 14.2819 11.8223 14.5151 12.1523C14.7281 12.4538 15.0011 12.8664 15.2515 13.209C15.551 13.6188 15.9306 13.9893 16.2935 14.3232C16.6751 14.6745 17.0256 14.9758 17.3618 15.3125C18.0272 15.9788 18.4184 16.578 18.4185 17.29C18.4185 18.1836 18.1807 18.7881 17.8462 19.1602C17.5207 19.522 17.0273 19.75 16.3247 19.75C15.59 19.75 15.1043 19.5743 14.4858 19.3555C13.8471 19.1295 13.1058 18.875 12.0005 18.875C10.8951 18.875 10.1539 19.1295 9.51514 19.3555C8.89671 19.5743 8.41092 19.7501 7.67627 19.75H7.67529C6.97272 19.7499 6.47924 19.5221 6.15381 19.1602C5.81931 18.7881 5.58154 18.1836 5.58154 17.29C5.58159 16.5778 5.97287 15.9778 6.63818 15.3115C6.9743 14.975 7.32505 14.6734 7.70654 14.3223C8.06922 13.9884 8.44921 13.6186 8.74854 13.209C8.99867 12.8667 9.27098 12.4547 9.48389 12.1533C9.71729 11.823 9.93776 11.5385 10.1763 11.3018C10.6248 10.8567 11.1525 10.5615 12.0005 10.5615Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M15.6787 3.76758C16.2863 3.8831 16.9119 4.73029 16.584 6.04688C16.4294 6.66667 16.0952 7.1726 15.7051 7.49316C15.3132 7.8151 14.909 7.9211 14.5732 7.85742C13.9659 7.74191 13.3401 6.89458 13.668 5.57812C13.8226 4.95851 14.1567 4.45246 14.5469 4.13184C14.9388 3.80985 15.3431 3.7039 15.6787 3.76758Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M7.80127 3.76758C8.13712 3.70398 8.5414 3.80993 8.93311 4.13184C9.32318 4.45244 9.65738 4.95843 9.81201 5.57812C10.1401 6.89448 9.51408 7.74192 8.90674 7.85742C8.57103 7.92107 8.16673 7.81505 7.7749 7.49316C7.38474 7.17258 7.05043 6.66663 6.896 6.04688C6.56791 4.73064 7.19414 3.88308 7.80127 3.76758Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M3.6582 8.4541C3.96257 8.39639 4.33461 8.49048 4.69922 8.79004C5.06219 9.0883 5.37406 9.56094 5.51855 10.1406H5.51953C5.82779 11.3766 5.23531 12.1497 4.69141 12.2529C4.3867 12.3108 4.01414 12.2157 3.64941 11.916C3.28653 11.6177 2.9745 11.1452 2.83008 10.5654C2.52223 9.32969 3.11331 8.55758 3.65723 8.4541H3.6582Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path
        d="M20.3423 8.4541C20.8524 8.55091 21.4041 9.2356 21.2173 10.3389L21.1704 10.5654C21.026 11.1453 20.7131 11.6176 20.3501 11.916C20.0307 12.1785 19.7056 12.2843 19.4253 12.2676L19.3081 12.2529L19.2056 12.2256C18.7278 12.0626 18.2586 11.3971 18.4331 10.3672L18.481 10.1406C18.6254 9.56095 18.9382 9.08835 19.3013 8.79004C19.6205 8.5279 19.9452 8.42286 20.2251 8.43945L20.3423 8.4541Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
    </svg>
  );
};
